<template>
  <div class="container-fluid">
    <TransitionPage>
      <div class="col-12">
        <nav class="navbar sticky-top navbg flex-row flex-md-nowrap p-0">
          <Header />
        </nav>
      </div>
    </TransitionPage>
    <TransitionPage>
      <div id="app" class="container-fluid" v-bind:class="topPad">
        <!-- <div class="d-flex col-3">Left</div>
      <div class="d-flex col-9">Middle
        <div class="d-flex col-9">ML</div>
        <div class="d-flex col-3">MR</div>
        </div>-->

        <div class="" :class="loggedInClass">
          <TransitionPage>
            <router-view :key="$route.fullPath" />
          </TransitionPage>
        </div>
      </div>
    </TransitionPage>
    <!-- <div
      class="fab-chat d-flex justify-content-center align-items-center shadow-lg"
    >
      <a href="https://jivo.chat/OqI9FvbeyI" target="_blank">
        <svg
          xmlns="http://www.w3.org/2000/svg"
          width="32"
          height="32"
          fill="#fff"
          class="bi bi-chat-dots-fill"
          viewBox="0 0 16 16"
        >
          <path
            d="M16 8c0 3.866-3.582 7-8 7a9.06 9.06 0 0 1-2.347-.306c-.584.296-1.925.864-4.181 1.234-.2.032-.352-.176-.273-.362.354-.836.674-1.95.77-2.966C.744 11.37 0 9.76 0 8c0-3.866 3.582-7 8-7s8 3.134 8 7zM5 8a1 1 0 1 0-2 0 1 1 0 0 0 2 0zm4 0a1 1 0 1 0-2 0 1 1 0 0 0 2 0zm3 1a1 1 0 1 0 0-2 1 1 0 0 0 0 2z"
          /></svg
      ></a>
    </div> -->

    <Footer class="footer-style" />
    <LiveChatWidget
      license="16968102"
      visibility="maximized"
      :customIdentityProvider="customIdentityProvider"
    />
  </div>
</template>

<script>
import TransitionPage from "@/components/TransitionPage.vue";
import Header from "@/components/Header.vue";
import LeftNav from "@/components/LeftNav.vue";
import Footer from "@/components/Footer.vue";
import { LiveChatWidget } from "@livechat/widget-vue";

export default {
  components: {
    TransitionPage,
    Header,
    LeftNav,
    Footer,
    LiveChatWidget
  },
  methods: {
    handleNewEvent(event) {
      console.log("LiveChatWidget.onNewEvent", event);
    },
    customIdentityProvider() {
      const baseAPI = process.env.VUE_APP_API_BASE_URL + "livechat";
      const userId = parseInt(localStorage.getItem("userId"));
      const getToken = async () => {
        const response = await fetch(`${baseAPI}/getToken/${userId}`);

        const token = await response.json();
        return token;
      };

      const getFreshToken = async () => {
        const response = await fetch(`${baseAPI}/getFreshToken/${userId}`);

        const token = await response.json();
        return token;
      };

      const hasToken = async () => {
        const response = await fetch(`${baseAPI}/hasToken/${userId}`);
        const data = await response.json();
        return data;
      };

      const invalidateToken = async () => {
        const response = await fetch(`${baseAPI}/invalidate/${userId}`);
        console.log(`${baseAPI}/invalidate/${userId}`);
        await response.json();
      };

      return {
        getToken,
        getFreshToken,
        hasToken,
        invalidate: invalidateToken
      };
    }
  },
  computed: {
    loggedIn() {
      return this.$store.state.apiEvents.jwt != "" ? 1 : 0;
    },
    loggedInClass() {
      return this.loggedIn ? "col-12" : " col-12";
    },
    topPad() {
      return this.$store.state.apiEvents.jwt != "" ? "top-pad" : "";
    },
    customerEmail() {
      return this.$store.state.apiEvents.username;
    }
  }
};
</script>

<style>
@import url("https://fonts.googleapis.com/css?family=Open+Sans:300,400,700");

html,
body {
  height: 100%;

  font-weight: 300 !important;
  font-style: normal !important;

  -ms-flex-align: center !important;
  -ms-flex-pack: center !important;
  -webkit-box-align: center !important;
  align-items: center !important;
  -webkit-box-pack: center !important;
  justify-content: center !important;
  background: #000000 !important;

  color: #fff !important;

  background-repeat: no-repeat;
  background-size: cover;
  background-position: center center;
  color: #000;
  height: 100%;
}

.footer-style {
  width: 100%;
  text-align: center;
}

.card-custom {
  padding: 20px;
  margin: 20px;
  border-radius: 15px;
  background-color: #1a1c22;
}

h2.header {
  color: #fff;
  font-size: 24px;
  font-weight: 300;
  text-transform: uppercase;
  letter-spacing: 2.4px;
  margin-bottom: 0px;
}

h3.header {
  color: #fff;
  font-size: 20px;
  font-weight: 300;
  text-transform: uppercase;
  letter-spacing: 2.4px;
  margin-bottom: 0px;
}

.card-header-track {
  color: #ffffff;
  font-size: 24px;
  font-family: "Open Sans";
  font-weight: 300;
  text-transform: uppercase;
  letter-spacing: 2.4px;
  background-color: #1f2348;
  padding: 23px 2%;
  border-bottom: none !important;
}

.card-header-project {
  color: #ffffff;
  font-size: 18px;
  font-family: "Open Sans";
  font-weight: 300;
  text-transform: uppercase;
  letter-spacing: 2.4px;
  background-color: #1f2348;
  padding: 20px;
  border-bottom: none !important;
}

.card-body-track {
  padding: 30px;
}

.fade-enter-active,
.fade-leave-active {
  transition-duration: 0.3s;
  transition-property: opacity;
  transition-timing-function: ease;
}

.fade-enter,
.fade-leave-active {
  opacity: 0;
}

.card-modal-header {
  color: #ffffff;
  font-size: 20px;
  font-family: "Open Sans";
  font-weight: 300;
  text-transform: uppercase;
  letter-spacing: 2.4px;
  background-color: #fff;
  padding: 23px 2%;
  border-bottom: none !important;
  border-radius: 2px 2px 0px 0px !important;
}

.card-modal-footer {
  background-color: #1a1c22;
  width: 100%;
  margin: 0px;
  display: flex !important;
  border-bottom: none !important;
  border-top: none !important;
  border-radius: 0px 0px 2px 2px !important;
}

.card-bg {
  background-color: #ffffff !important;
  width: 100%;
  margin: 0px;
  border-bottom: none !important;
  border-top: none !important;
}

.input-modal-bg {
  color: #1a1c22;
  font-size: 16px;
  width: 100%;
  font-family: "Open Sans";
  font-weight: 300;
  background-color: #e1e1e1;
  margin: 4px;
  padding: 4px;
  border: none !important;
  border-radius: 2px 2px 0px 0px !important;
}

.input-modal-bg:active,
.input-modal-bg:focus {
  outline: none;
  border: none;
}

.top-pad {
  margin-top: 20px;
}

.fade-enter-active,
.fade-leave-active {
  transition: opacity 0.5s;
}

.fade-enter,
.fade-leave-to

/* .fade-leave-active below version 2.1.8 */
 {
  opacity: 0;
}
</style>
